import type { FormProps, SanityEnrichedForm } from '#/lib/sanity/queries/form';
import { cn } from '#/lib/utils';
import { BasicText } from '#/components/BasicText';

import { EnrichedForm } from '../Enriched';
import { addBusinessEmailValidation } from '../utils';
import { FormConfirmation } from './Confirmation';
import { FormErrorMessage } from './ErrorMessage';

type Props = FormProps<SanityEnrichedForm>;

export function FormCustomEnriched(props: Props) {
  const formFieldsSchema = addBusinessEmailValidation(props.form);

  return (
    <div className={cn('relative', props.className)}>
      <EnrichedForm
        formTitle={props.form.formTitle}
        theme={props.theme}
        fieldGroups={props.form.fieldGroups}
        hubspotCampaignId={props.form.hubspotCampaignId}
        hubspotConvertingFormType={props.form.hubspotConvertingFormType}
        contentPieceTitle={props.form.contentPieceTitle}
        hubspotEmailSubscriptionIds={props.form.hubspotEmailSubscriptionIds}
        chiliPiperRouterId={props.form.chiliPiperRouterId}
        formFieldsSchema={formFieldsSchema}
        trackingEventName={props.form.trackingEventName}
        submitButtonLabel={props.form.submitButtonLabel}
        strictEnrichment={props.form.strictEnrichment}
        trackingEventProperties={props.form.trackingEventProperties}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
        ConfirmationComponent={() => (
          <FormConfirmation
            confirmation={props.confirmation}
            theme={props.buttonTheme ?? props.theme}
          />
        )}
      >
        {({ formState }) => {
          return (
            <>
              <FormErrorMessage
                className="col-span-full"
                formState={formState}
              />
              {props.form.legalText && props.form.legalText.length > 0 ? (
                <BasicText
                  className={cn(
                    'legal-text col-span-full mt-10 font-light text-grayscale-05',
                    props.theme === 'dark' && 'text-grayscale-03',
                  )}
                  value={props.form.legalText}
                />
              ) : null}
            </>
          );
        }}
      </EnrichedForm>
    </div>
  );
}
